module.exports = __webpack_public_path__ + "img/orgel.7b5409b9.png";